import styled from 'styled-components';
import { FlexColumn, Text, FlexRow } from '@make-software/tg-mini-app-ui';

export const ErrorText = styled.span`
  text-align: center;
  color: ${({ theme }) => theme.colors.errorText};
`;

export const ProviderButtonsCol = styled(FlexColumn)`
  gap: 4px;
  justify-content: space-between;
  width: 80%;
`;

export const ProviderIcon = styled.img`
  filter: brightness(0);
  transition: filter 0.2s ease;
`;

export const StyledHeader = styled(Text)(({ theme }) =>
  theme.withMedia({
    color: theme.colors.lightGray,
    fontSize: '18px',
    fontFamily: theme.typography.fontFamily.display,
    fontWeight: 300,
    lineHeight: '140%'
  })
);

export const StyledButtonCaption = styled(Text)(({ theme }) =>
  theme.withMedia({
    color: '#000000',
    fontSize: '16px',
    fontFamily: theme.typography.fontFamily.display,
    fontWeight: 600,
    lineHeight: '100%',
    transition: 'color 0.2s ease'
  })
);

export const ProviderButtonContent = styled(FlexRow)`
  button:hover & ${ProviderIcon} {
    filter: brightness(0) invert(1);
  }

  button:hover & ${StyledButtonCaption} {
    color: white;
  }
`;

export const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    position: 'absolute' as const,
    padding: '20px',
    boxShadow: 'inset 0 0 0 1px #41424E',
    width: '80%',
    maxWidth: '500px'
  }
};
